import { Box } from '@mantine/core'
import { IconChevronsDown } from '@tabler/icons-react'

export function ScrollDownIndicator({ viewportRef, visible }) {
  const handleClick = (e) => {
    e.stopPropagation()
    if (viewportRef?.current) {
      const viewport = viewportRef.current
      viewport.scrollBy({ top: viewport.clientHeight - 40, behavior: 'smooth' })
    }
  }

  return (
    <Box
      style={{
        position: 'absolute',
        bottom: 0,
        left: 0,
        right: 0,
        height: 40,
        background: 'linear-gradient(transparent, rgba(6, 14, 26, 0.9))',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'flex-end',
        paddingBottom: 8,
        pointerEvents: 'none',
        opacity: visible ? 1 : 0,
        transition: 'opacity 0.3s ease',
        zIndex: 1,
      }}
    >
      <Box
        className="scroll-indicator-pulse"
        onClick={handleClick}
        style={{
          pointerEvents: visible ? 'auto' : 'none',
          cursor: 'pointer',
          color: 'rgba(0, 255, 255, 0.8)',
          lineHeight: 0,
        }}
      >
        <IconChevronsDown size={22} />
      </Box>
    </Box>
  )
}
